import { render, staticRenderFns } from "./StatusSummary.vue?vue&type=template&id=7b103c90&"
import script from "./StatusSummary.vue?vue&type=script&lang=js&"
export * from "./StatusSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b103c90')) {
      api.createRecord('7b103c90', component.options)
    } else {
      api.reload('7b103c90', component.options)
    }
    module.hot.accept("./StatusSummary.vue?vue&type=template&id=7b103c90&", function () {
      api.rerender('7b103c90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/widgets/StatusSummary.vue"
export default component.exports